<span id="wrapper" [ngStyle]="justifyContentStyle">
  @if (startDate) {
    <span id="left">
      <div class="itemDate" [ngStyle]="itemDateStyle">
        {{ startDate | date: (showYear ? 'dd.MM.yyyy' : 'dd.MM.') }}
      </div>
      <div class="itemTime" [ngStyle]="itemTimeStyle">
        {{ startDate | date: 'HH:mm' }}
      </div>
    </span>
  }
  @if (startDate && endDate) {
    <div id="divider">-</div>
  }
  @if (endDate) {
    <span id="right">
      <div class="itemDate" [ngStyle]="itemDateStyle">
        {{ endDate | date: (showYear ? 'dd.MM.yyyy' : 'dd.MM.') }}
      </div>
      <div class="itemTime" [ngStyle]="itemTimeStyle">
        {{ endDate | date: 'HH:mm' }}
      </div>
    </span>
  }
</span>
